import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const TEST_MODE = process.env.REACT_APP_TEST_MODE === 'true';

// Analytics is intentionally event-only, no PII:
// - autocapture/session recording are off, so we never ship raw DOM text
//   (which would include real dollar amounts) or screen recordings.
// - we never call posthog.identify() with an email or other PII — every
//   user is tracked as an anonymous, device-local distinct_id.
// - TEST_MODE (used for local dev and the Playwright mock-data screenshots)
//   never initializes PostHog, so demo sessions don't pollute real data.
const enabled = !!POSTHOG_KEY && !TEST_MODE;

export const initAnalytics = () => {
  if (!enabled) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: true,
    person_profiles: 'identified_only',
  });
};

export const trackEvent = (name, properties = {}) => {
  if (!enabled) return;
  posthog.capture(name, properties);
};

export const trackPageview = (path) => {
  if (!enabled) return;
  posthog.capture('$pageview', { $current_url: path });
};
